import React from 'react';
import { Link, Redirect, useLocation, useHistory } from 'react-router-dom';

const useGoLogin = (
	isModal = true,
	routerLocation = null,
	routerHistory = null,
) => {
	const locationHooks = useLocation();
	const historyHooks = useHistory();
	const location = routerLocation || locationHooks;
	const history = routerHistory || historyHooks;

	const url = {
		pathname: '/signin',
	};

	if (isModal) url.state = { background: location };

	const goLogin = () => history.push(url);

	const LoginLink = ({ children, ...props }) => (
		<Link to={url} {...props}>
			{children}
		</Link>
	);

	const LoginRedirect = () => <Redirect to={url} />;

	return { goLogin, LoginLink, LoginRedirect };
};

export default useGoLogin;
